<template>
  <section class="intrare-noua">
    <main class="relative">
      <div v-if="isAutocomplete && $store.getters[activeField] && $store.getters[activeField].length">
        <Autocomplete ref="autocomplete"
                      :name="autocompleteFieldName"
                      :positionY="autocompletePositionY"
                      :positionX="autocompletePositionX"
                      :list="$store.getters[activeField]"
                      @select-item="handleAutocompleteItem"
                      @hide="hideAutocomplete" />
      </div>

      <ValidationObserver v-slot="{ handleSubmit }">
        <div v-if="$router.currentRoute.params.id"
             class="top-actions">
          <router-link cy="comanda-btn"
                       :to="'/comanda/' + $router.currentRoute.params.id">
            <button>COMANDĂ</button>
          </router-link>
          <router-link cy="deviz-btn"
                       :to="'/deviz/' + $router.currentRoute.params.id">
            <button>DEVIZ</button>
          </router-link>
        </div>
        <form @submit.prevent="handleSubmit(submit)"
              class="relative mauto">

          <!-- DETALII AUTO -->
          <div class="step step-1">
            <div class="flex align-center flex-between">
              <h2>
                <span class="number">1</span>
                {{ lang.autoDetails }}
              </h2>
            </div>

            <ul>
              <li v-for="(item, index) in auto"
                  :key="index">
                <validation-provider :rules="item.rules"
                                     v-slot="{ errors }">
                  <div class="input-group flex"
                       :class="{focus: item.model === activeField,
                                'invalid-input': errors[0]}"
                       :cy="`input-group-${item.model}`">
                    <label :for="item.model">{{ item.label }}</label>
                    <input :id="item.model"
                           :cy="item.model"
                           :ref="item.model"
                           v-model="data.car[item.model]"
                           class="uppercase"
                           @focus="handleCarFieldFocus($event, item.model)"
                           @blur="activeField = undefined"
                           @keyup="handleCarFieldInput($event, item.model)"
                           type="text"
                           autocomplete="off"
                           placeholder="">
                  </div>
                </validation-provider>
              </li>
              <li>
                <textarea v-model="data.car.observatii"
                          name="observatii" placeholder="observații"></textarea>
              </li>
            </ul>
          </div>

          <!-- DETALII CLIENT -->
          <div class="step step-2">
            <h2>
              <span class="number">2</span>
              {{ lang.clientDetails }}
            </h2>

            <ul>
              <li v-for="(item, index) in client"
                  :key="index">
                <validation-provider :rules="item.rules"
                                     v-slot="{ errors }">
                  <div class="input-group flex"
                       :class="{focus: index === activeField,
                                    'invalid-input': errors[0]}"
                       :cy="`input-group-${item.model}`">
                    <label :for="item.model">{{ item.label }}</label>
                    <input :id="item.model"
                           :cy="item.model"
                           v-model="data.client[item.model]"
                           class="uppercase"
                           @focus="activeField = index"
                           @blur="activeField = undefined"
                           :type="item.type || 'text'"
                           :autocomplete="'as9dasd11' + item.model"
                           placeholder="">
                  </div>
                </validation-provider>
              </li>
            </ul>

          </div>

          <!-- DETALII REPARATII -->
          <div class="step step-3">
            <h2>
              <span class="number">3</span>
              {{ lang.repairsDetails }}
            </h2>

            <ul>
              <li>
                <span class="label">Defectiuni:</span>
                <div cy="defectiuni"
                     ref="defectiuni"
                     contenteditable="true"
                     v-html="data.comanda.defectiuni"></div>
              </li>
              <li>
                <span class="label">Piese client:</span>
                <div cy="piese-client"
                     ref="piese_client"
                     contenteditable="true"
                     v-html="data.comanda.piese_client"><div></div></div>
              </li>
            </ul>
          </div>

          <!-- PROGRAMARE -->
          <div class="step step-4">
            <h2 class="capitalize">
              <span class="number">4</span>
              {{ lang.programareNouaStepTitle }}
            </h2>

            <label>
              {{ lang.date }}
            </label>
            <DatePicker class="date-input"
                        cy="booking-date"
                        v-model="bookingDate" />
            <br>
            <label>
              {{ lang.time }}
            </label>
            <ClockTimePicker class="date-input"
                             cy="booking-time"
                             v-model="bookingTime" />
          </div>

          <div class="actions flex">
            <button @click="anuleaza"
                    cy="cancel">
              {{ lang.quitBtn }}
            </button>
            <button class="flex-center"
                    cy="submit">
              {{ lang.saveBtn }}
            </button>
          </div>
        </form>
      </ValidationObserver>
    </main>
  </section>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import ClockTimePicker from '../components/time-picker/ClockTimePicker.vue'
  import DatePicker from '../components/date-picker/DatePicker.vue'
  export default {
    name: 'IntrareNoua',
    components: { ClockTimePicker, DatePicker },
    data () {
      return {
        autocompleteFieldName: undefined,
        autocompletePositionY: 0,
        autocompletePositionX: 0,
        booking_date: this.formatDate(),
        booking_time: this.formatTime(),
        auto: [
          {
            label: 'Număr auto',
            model: 'numar',
            rules: 'required'
          },
          {
            label: 'Marcă',
            model: 'marca',
            rules: 'required'
          },
          {
            label: 'Model',
            model: 'model',
            rules: 'required'
          },
        ],
        client: [
          {
            label: 'Nume',
            model: 'nume',
            rules: 'required'
          },
          {
            label: 'Telefon',
            model: 'telefon',
            type: 'number'
          }
        ],
        activeField: undefined,
        autocompleteFields: [
          {
            field: 'numar',
            commit: 'FILTER_CAR_NUMBER'
          },
          {
            field: 'marca',
            commit: 'FILTER_CAR_BRAND'
          },
          {
            field: 'model',
            commit: 'FILTER_CAR_MODEL'
          }
        ],
        isAutocomplete: false
      }
    },
    created () {
      const id = this.$router.currentRoute.params.id
      this.$store.dispatch('get_cars_numbers_templates')
      id && this.$store.dispatch('get_comanda', id)
    },
    computed: {
      ...mapState({
        data: state => state.comenzi.comanda
      }),
      ...mapGetters(['numar', 'marca', 'model', 'lang']),
      bookingDate: {
        get () {
          return this.data.booking_date || ''
        },
        set (value) {
          this.$store.commit('UPDATE_COMANDA_NOUA_FIELD', {key: 'booking_date', value})
        }
      },
      bookingTime: {
        get () {
          return this.data.booking_time || ''
        },
        set (value) {
          this.$store.commit('UPDATE_COMANDA_NOUA_FIELD', {key: 'booking_time', value})
        }
      }
    },
    methods: {
      formatDate (date = new Date()) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      },
      formatTime (date = new Date()) {
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
      },
      submit () {
        const fields = ['cerinte_client', 'defectiuni', 'piese_client']
        fields.forEach((key) => {
          const htmlVal = this.$refs[key]?.innerHTML
          this.$store.commit('UPDATE_COMANDA_HTML_FIELD', {key, htmlVal})
        })
        if (this.data._id) {
          this.$store.dispatch('update_comanda', this.data._id)
        }
        else {
          this.data.status = 0
          this.$store.dispatch('create_programare', this.data);
        }
      },
      anuleaza () {
        this.$store.commit('SET_KEY_VALUE', { key: 'comanda', value: {} })
        this.$router.push('/programari')
      },
      handleAutocompleteItem ({name, value}) {
        if (name === 'numar') {
          const details = this.$store.state.templates.carsNumbers
              .filter(o => o.numar === value)[0]
          this.$store.commit('SET_CAR_DETAILS', details)
        } else {
          this.$store.commit('SET_CAR_FIELD_VALUE', {name, value})
        }
        this.isAutocomplete = false
        const elmIndex = this.auto.findIndex(o => o.model === name)
        setTimeout(() => {
          const index = name === 'numar' ? elmIndex + 4 : elmIndex + 1
          this.$refs[this.auto[index]?.model]?.[0]?.focus()
        }, 0)
        name === 'marca' && this.$store.commit('SET_CARS_MODELS', value)
      },
      handleCarFieldFocus ({target}, fieldName) {
        this.activeField = fieldName
        const section = this.autocompleteFields.filter(o => o.field === fieldName)
        this.isAutocomplete = !!section.length
        this.autocompleteFieldName = fieldName
        this.autocompletePositionY = target.offsetTop + 39
        this.autocompletePositionX = target.offsetLeft + 16
      },
      handleCarFieldInput ({key}, fieldName) {
        if (this.isAutocomplete) {
          const section = this.autocompleteFields.filter(o => o.field === fieldName)[0]
          const value = this.data.car[fieldName] || ''
          const a_z = /[0-9a-zA-Z]/.test(key) && key.length === 1
          switch (key) {
            case 'Backspace':
              this.$store.commit(section.commit, value.toLowerCase())
              break
            default:
              !!value && a_z && this.$store.commit(section.commit, value.toLowerCase())
          }
        }
      },
      hideAutocomplete () {
        this.isAutocomplete = false
      }
    },
    destroyed () {
      this.$store.commit('RESET_FORMULAR_INTRARE_NOUA')
    },
    watch: {
      $route(to) {
        !to.params.id && this.$store.commit('RESET_FORMULAR_INTRARE_NOUA')
      }
    }
  }
</script>

<style lang="less">
  @import "../styles/var";
  .intrare-noua {
    @media only screen and (min-width: 0) {
      min-height: 100%;
      padding-top: 50px;
      background-color: @gray;
      padding: 0 10px;

      main {
        width: 100%;
        max-width: 750px;
        margin: 0 auto;
        padding-bottom: 100px;
      }
      .number {
        padding: 0 20px;
        font-size: 3.8rem;
        font-family: "Avenir-Black", sans-serif!important;
      }
      h2 {
        font-size: 2rem;
      }

      form {
        ul {
          padding: 0 16px;
        }
        input:not(.date-input) {
          width: 100%;
          height: 38px;
          border-radius: var(--border-radius);
          padding-left: 16px;
          font-size: 1.8rem;
          background-color: transparent;
          font-weight: bold;
        }
        textarea {
          width: 100%;
          height: 100px;
          resize: none;
          box-sizing: border-box;
          border: none;
          font-size: 1.8rem;
          padding-left: 10px;
          padding-top: 10px;
        }
        .input-group {
          width: 100%;
          margin-bottom: 1px;
          background-color: white;
          label {
            width: 190px;
            padding-top: 8px;
            padding-left: 12px;
            font-size: 1.8rem;
          }
        }
        .focus {
          box-shadow: inset 0 0 8px 0 rgba(50, 50, 50, 0.4);
        }
      }

      .step {
        padding: 4px 0 80px 0;
      }
      .top-actions {
        display: flex;
        position: absolute;
        top: 20px;
        right: 0;
        z-index: 9;
        a {
          cursor: pointer;
          display: inline-block;
        }
        button {
          border: none;
          padding: 8px 20px;
          font-size: 1.6rem;
          font-weight: bold;
          border-radius: var(--border-radius);
          color: white;
          transition: background-color .1s ease-in-out;
          &:first-child {
            margin-right: 20px;
            background-color: var(--blue);
            &:hover {
              background-color: darken(#29abe2, 20%, relative)!important;
            }
          }
          &:last-child {
            background-color: var(--orange);
            &:hover {
              background-color: darken(#f7931e, 20%, relative)!important;
            }
          }
        }
      }

      .step-1 > div:first-child {
        padding-right: 0px;
      }
      span.label {
        margin-bottom: 4px;
        display: block;
        font-size: 1.6rem;
        color: black;
      }
      .step-1, .step-3 {
        background-color: #3E3D3E;
        h2 {
          color: white;
        }
      }

      .step-2 {
        background-color: #d6d6d6;
        .number {
          color: @dark-gray;
        }
      }

      .step-3 {
        background-color: var(--red);
        span.label {
          color: white;
        }
      }

      .step-4 {
        background-color: #b0cedb;
        span.label {
          color: white;
        }
        label,
        .date-input {
          width: 300px;
          margin: 0 auto;
          display: block;
          border-radius: 4px;
        }
        label {
          font-size: 1.7rem;
          padding-bottom: 4px;
        }
        .date-input {
          font-size: 2rem;
          line-height: 2.1;
          color: @dark-gray;
          text-align: center;
        }
      }

      .invalid-input {
        border: none!important;
        label {
          color: red;
        }
      }

      .actions {
        margin-top: 20px;
        //justify-content: center;
        button {
          height: 40px;
          padding: 0 20px;
          font-size: 2rem;
          border-radius: var(--border-radius);
          font-weight: bold;
          &:first-child {
            margin-right: 30px;
            background-color: @light-gray;
            transition: background-color .1s ease-in-out;
            &:hover {
              background-color: darken(@light-gray, 20%, relative)!important;
            }
          }
          &:last-child {
            color: white;
            background-color: @dark-green;
            transition: background-color .1s ease-in-out;
            &:hover {
              background-color: darken(@dark-green, 20%, relative)!important;
            }
          }
        }
      }
      div[contenteditable] {
        min-height: 80px;
        margin-bottom: 8px;
        padding: 8px;
        background-color: white;
        font-size: 1.6rem;
        > div:first-child {
          min-height: 20px;
          line-height: 16px;
        }
      }
    }

    @media only screen and (max-width: 1024px) {
      main {
        overflow: scroll;
      }
    }

    @media only screen and (min-width: 1024px) {
      main {
        margin: 40px auto 0;
        .step-1 > div:first-child {
          padding-right: 40px;
        }
      }
      form {
        ul {
          padding: 0 67px;
        }
        .date-input {
          cursor: pointer;
        }
      }
      .actions {
        button {
          &:first-child {
            margin-left: auto;
          }
        }
      }
    }
  }
</style>
